// extracted by mini-css-extract-plugin
export var disabled = "_m-4";
export var error = "_m-1";
export var fitContent = "_m-5";
export var iconWrapper = "_m-9";
export var infoIconWrapper = "_m-b _m-9";
export var input = "_m-8";
export var inputWrapper = "_m-0";
export var large = "_m-7";
export var leadingIconWrapper = "_m-a _m-9";
export var measureBox = "_m-c";
export var medium = "_m-6";
export var readonly = "_m-2";
export var small = "_m-3";